import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {canAccessRouteWithoutAuthenticationGuard} from '@application/security/can-access-route-without-authentication-guard';
import {LoginComponent} from '@presentation/pages/login/login.component';

export const routes: Routes = [{path: '', component: LoginComponent, canActivate: [canAccessRouteWithoutAuthenticationGuard]}];

export const loginRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(routes);
